import { ActionReducerMap } from '@ngrx/store';

import { IAppState } from '../states/app.state';
import { uiReducers } from './ui.reducers';
import { directorListReducers } from './director-list.reducers';
import { largeShareholderListReducers } from './large-shareholder-list.reducers';
import { pyramidalShareholderListReducers } from './pyramidal-shareholder-list.reducers';
import { companyFormReducers } from './company-form.reducers';
import { companyListReducers } from './company-list.reducers';
import { companyVoteProposalNameListReducers } from './company-vote-proposal-name-list.reducers';
import { companyVoteResultListReducers } from './company-vote-result-list.reducers';
import { opbCompanyListReducers } from './opb-company-list.reducers';
import { portalDirectorsListReducers } from './portal-directors-list.reducers';

export const appReducers: ActionReducerMap<IAppState, any> = {
    ui: uiReducers,
    directorList: directorListReducers,
    largeShareholderList: largeShareholderListReducers,
    pyramidalShareholderList: pyramidalShareholderListReducers,
    companyForm: companyFormReducers,
    companyList: companyListReducers,
    companyVoteProposalNameList: companyVoteProposalNameListReducers,
    companyVoteResultList: companyVoteResultListReducers,
    opbCompanyList: opbCompanyListReducers,
    portalDirectorsList: portalDirectorsListReducers
};
